import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/HowMFPSTransformingIndustryHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-20.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .hmf { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .hmf-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .hmf-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .hmf-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .hmf-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .hmf-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .hmf-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .hmf-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .hmf-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .hmf-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .hmf-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .hmf-bc-item:hover { color: #EB2019; }
  .hmf-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .hmf-bc-sep img { width: 24px; height: 24px; display: block; }
  .hmf-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .hmf-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .hmf-main-section { padding: 80px 0 120px 0; }
  .hmf-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .hmf-article { flex: 1; min-width: 0; }

  .hmf-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .hmf-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .hmf-meta-item:last-child { border-right: none; padding-right: 0; }
  .hmf-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .hmf-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .hmf-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .hmf-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .hmf-article-body p { margin-bottom: 20px; }
  .hmf-article-body p:last-child { margin-bottom: 0; }

  .hmf-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .hmf-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .hmf-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .hmf-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .hmf-article-body ul li > span { flex: 1; }

  .hmf-article-body strong { font-weight: 600; color: #202020; }

  .hmf-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .hmf-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .hmf-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .hmf-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .hmf-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .hmf-nav-btn:hover { color: #EB2019; }
  .hmf-nav-btn img { width: 40px; height: 40px; display: block; }

  .hmf-share-icons { display: flex; align-items: center; gap: 20px; }
  .hmf-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .hmf-share-icon:hover { opacity: 0.85; }
  .hmf-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .hmf-sidebar { flex: 0 0 475px; }
  .hmf-sidebar-block { margin-bottom: 60px; }
  .hmf-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .hmf-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .hmf-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .hmf-recent-item:hover .hmf-recent-title { color: #EB2019; }
  .hmf-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .hmf-recent-body { flex: 1; min-width: 0; }
  .hmf-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .hmf-social-icons { display: flex; align-items: center; gap: 30px; }
  .hmf-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .hmf-social-icon:hover { opacity: 0.8; }
  .hmf-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .hmf-hero             { height: 350px; }
    .hmf-hero-content     { padding: 0 32px; }
    .hmf-hero-title       { font-size: 30px; }
    .hmf-hero-divider     { width: 100%; max-width: 479px; }
    .hmf-breadcrumb       { padding: 24px 0 0 0; }
    .hmf-breadcrumb-inner { padding: 0 32px; }
    .hmf-inner            { padding: 0 32px; }
    .hmf-main-section     { padding: 48px 0 60px 0; }
    .hmf-main-row         { flex-direction: column; gap: 48px; }
    .hmf-sidebar          { flex: none; width: 100%; }
    .hmf-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .hmf-hero             { height: 360px; }
    .hmf-hero-content     { padding: 0 16px; }
    .hmf-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .hmf-hero-divider     { width: 100%; }
    .hmf-hero-subtitle    { font-size: 14px; }
    .hmf-breadcrumb       { padding: 30px 0 0 0; }
    .hmf-breadcrumb-inner { padding: 0 16px; }
    .hmf-bc-item          { font-size: 14px; gap: 14px; }
    .hmf-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .hmf-bc-sep img       { width: 22px; height: 22px; }
    .hmf-inner            { padding: 0 16px; }
    .hmf-main-section     { padding: 30px 0 60px 0; }
    .hmf-main-row         { flex-direction: column; gap: 60px; }
    .hmf-sidebar          { flex: none; width: 100%; }
    .hmf-article-title    { font-size: 20px; margin-bottom: 15px; }
    .hmf-article-body     { font-size: 14px; }
    .hmf-article-body p   { margin-bottom: 15px; }
    .hmf-article-body ul li { font-size: 14px; }
    .hmf-meta-item        { font-size: 14px; }
    .hmf-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .hmf-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .hmf-nav-btn img      { width: 24px; height: 24px; }
    .hmf-nav-btn          { font-size: 14px; }
    .hmf-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
    {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },

];

export default function HowMediumFrequencyPowerSwitchingTransformingIndustry() {
  return (
    <div className="hmf">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="hmf-hero">
        <img className="hmf-hero-bg" src={HeroBgImg} alt="MFPS Transforming Industry Hero" />
        <div className="hmf-hero-overlay" />
        <div className="hmf-hero-content">
          <h1 className="hmf-hero-title">
            How Is Medium-Frequency Power Switching Transforming Industry?
          </h1>
          <hr className="hmf-hero-divider" />
          <p className="hmf-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="hmf-breadcrumb" aria-label="Breadcrumb">
        <div className="hmf-breadcrumb-inner">
          <a href="/" className="hmf-bc-item">Home</a>
          <span className="hmf-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="hmf-bc-item">News &amp; Updates</a>
          <span className="hmf-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="hmf-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="hmf-main-section">
        <div className="hmf-inner">
          <div className="hmf-main-row">

            {/* ── ARTICLE ── */}
            <article className="hmf-article">

              {/* Meta bar */}
              <div className="hmf-meta-bar">
                <span className="hmf-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="hmf-meta-item"><img src={CalendarIcon} alt="date" /> April 23, 2025</span>
                <span className="hmf-meta-item"><img src={ClockIconImg} alt="time" /> 6:50 am</span>
                <span className="hmf-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="hmf-article-title">
                How Is Medium-Frequency Power Switching Transforming Industry?
              </h1>

              {/* Body */}
              <div className="hmf-article-body">

                <p>Efficiency and precision are no longer optional in high-demanding industrial environments. One significant invention pushing this transformation is <strong>medium-frequency power switching</strong>. This technology changes how industries address power delivery in crucial applications like <strong>electrostatic precipitators</strong> (ESPs), welding systems, and furnace operations. This technology is changing the game and how!</p>

                <p>Let's dive in!</p>

                {/* Article image */}
                <img className="hmf-article-img" src={ArticleImg} alt="Medium Frequency Power Switching" />

                <span className="hmf-h2">Understanding Medium-Frequency Power Switching</span>

                <p>Medium-frequency power switching involves converting AC power into high-frequency DC or controlled AC outputs, typically from 1kHz to 20kHz. It's made possible using advanced semiconductor devices—especially <a href="/igbt-modules-the-power-behind-modern-electronics/" className="hmf-red-link">IGBT modules</a> (Insulated Gate Bipolar Transistors)—that allow high-speed switching while maintaining efficiency and thermal control.</p>

                <span className="hmf-h2">Does Medium Frequency matter in industrial applications</span>

                <p>Traditional <strong>transformer rectifier</strong> (T/R) systems function at common line frequencies (50/60Hz), determining their response time and efficiency.</p>

                <p><strong>By pivoting to medium-frequency switching, enterprises can reap substantial advantages:</strong></p>

                <span className="hmf-h2">Faster Response Time</span>

                <p>Medium-frequency switching allows quicker pulse control, which means real-time adjustments to process conditions—which is essential in dynamic industrial environments.</p>

                <span className="hmf-h2">Higher Energy Efficiency</span>

                <p>Thanks to the lower conduction and switching losses offered by <strong>IGBT modules</strong>, less energy is lost in heat. The result? Reduced power consumption and better thermal management.</p>

                <span className="hmf-h2">Improved ESP Performance</span>

                <p>In <strong>electrostatic precipitators</strong>, medium-frequency switching delivers smoother voltage and current output, improving particle charging and collection. This leads to better dust removal efficiency and lower emissions—supporting compliance with global environmental norms.</p>

                <span className="hmf-h2">Applications Across Key Industries</span>

                <p>From <strong>cement</strong> and <strong>steel</strong> to <strong>power generation</strong>, the impact of medium-frequency switching is felt across multiple sectors:</p>

                <ul>
                  <li><span>In steel plants, precise power control during melting and refining improves product quality.</span></li>
                  <li><span>In pulp and paper, smoother ESP operation minimizes plant downtime.</span></li>
                  <li><span>Enhancing emission control through improved ESP efficiency in power plants reduces environmental impact.</span></li>
                </ul>

                <span className="hmf-h2">The Role of IGBT Modules in This Transformation</span>

                <p><strong>IGBT modules</strong> are the heart of medium-frequency switching. They provide the high-speed, high-voltage switching capability needed for advanced T/R systems. Their integration leads to compact design, intelligent fault handling, and reliable long-term operation—even in harsh industrial environments.</p>

                <span className="hmf-h2">Final Thoughts</span>

                <p>Medium-frequency power switching is an upgrade and a step toward a more innovative, sustainable industry. With better efficiency, lower emissions, and higher reliability, it aligns with the global push for cleaner and more responsive industrial systems.</p>

                <p><strong>ADOR POWERTRON</strong> offers advanced medium-frequency transformer <strong>rectifier</strong> systems built with high-performance <strong>IGBT modules</strong> optimized for <strong>electrostatic precipitators</strong> and emission control in the world's most demanding industries.</p>

                <p><a href="/contact-us" className="hmf-red-link">Let's power a cleaner future—connect with ADOR today.</a> Contact us now!</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="hmf-bottom-row">
                <div className="hmf-bottom-nav">
                  <a href="/news/how-to-select-right-smps" className="hmf-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/complete-guide-emission-control-systems" className="hmf-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="hmf-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/how-is-medium-frequency-power-switching-transforming-industry/" className="hmf-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fhow-is-medium-frequency-power-switching-transforming-industry%2F&mode=login" className="hmf-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-is-medium-frequency-power-switching-transforming-industry%2F%26title%3DMedium%2520Frequency%2520Power%2520Switching%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-is-medium-frequency-power-switching-transforming-industry%2F" className="hmf-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="hmf-sidebar">

              {/* Recent Posts */}
              <div className="hmf-sidebar-block">
                <p className="hmf-sidebar-title">Recent Posts</p>
                <div className="hmf-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="hmf-recent-item">
                      <img src={post.img} alt={post.title} className="hmf-recent-img" />
                      <div className="hmf-recent-body">
                        <span className="hmf-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="hmf-sidebar-block">
                <p className="hmf-sidebar-title">Social Media</p>
                <div className="hmf-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="hmf-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="hmf-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}